export const Constants = {
    SomethingWentWrongMsg: "Something went wrong. Please try again later.",
    ErrorReachingServer: "Failed to perform the operation. The server may be unreachable or experiencing issues. Please try again later.",
    PlanType: {
        Basic: "basic",
        Professional: "professional",
        ProAlias: "pro",
    },
    //New Post
    NewPost: {
        AspectRatioErrorMessage: "Aspect Ratio is not in the correct format"
    }
}
